import { baseOptions } from './config/baseOptions';

const tourBuilderRegistry = {};
/**
 * Registers the tour builds to create tours with.
 *
 * @param {string} tourName The key to use in `createTour()`; tours should
 *  export their `tourName`.
 * @param {Function} tourBuilder The tour factory method; expected to accept
 *  `t` param for translations and return object in the form `(t) => {return {...}};`
 */
export const registerTourProduct = (tourName, tourBuilder) => {
  if (tourBuilderRegistry[tourName]) {
    throw new Error(
      `Cannot register tour '${tourName}' more than once; rename one of them?`
    );
  }
  tourBuilderRegistry[tourName] = tourBuilder;
};

/**
 * Creates a locale appropriate tour mixed into the base options.
 *
 * Custom values we should preface with `novus` to avoid potential collisions.
 *
 * @param {object} params Object parameter
 *  - {string} tourName The key to use in `registerTour()`; tours should
 *  export their `tourName`.
 *  - {Function} t translate
 *  - {object} props The caller's props; should be simple.
 * @return {object} The introJs options object with the tour steps. Expected to contain:
 *   {steps: [...], novusPagePath: string|false, novusNextPageLabel: string }
 */
export const createTourOptions = ({ tourName, t, props }) => {
  if (!tourBuilderRegistry[tourName]) {
    throw new Error(`No tour registered with name ${tourName}.`);
  }
  let options = {
    ...baseOptions(t),
    ...tourBuilderRegistry[tourName](t)
  };
  options.novusProps = options.novusProps
    ? Object.assign(options.novusProps, props)
    : props;
  return options;
};



// WEBPACK FOOTER //
// ./src/actions/onboarding/onboardingTourFactory.js